<template>
  <section v-show="elementVisible" class="notification" id="notification">
    <p class="notification__control" @click="onCloseNotification"><i class="fa fa-times" aria-hidden="true"></i> </p>
    <div class="wrap__notification">
        <h6 class="wrap__notification__title">
           {{$t('userNotification.title')}}
        </h6>
        <div class="wrap__notification__body">
            <img id="img" class="wrap__notification__body__img" :src="require(`@/assets/${imgIcon}`)" alt="user image">
            <span class="wrap__notification__body__username">{{user.firstname}}</span>
        </div> 
    </div>

  </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name:'UserNotification',
    data(){
        return{
            imgIcon:'',
            timeOut:null,
            elementVisible: true
        }
    },
    computed: {
    ...mapGetters({
      user: 'auth/authenticatedUser',
    }),
  },
    created(){
        //1=Student , 2=Parent
        this.user.rol_id===1 ? this.imgIcon='child_login.svg':this.imgIcon='parent_login.svg';
    },
    methods:{
        onCloseNotification(){
            clearTimeout(this.timeOut);
                var notification=document.getElementById("notification");
               // notification.style.transform = "translate(calc(100vw))"
                notification.style.opacity = "0"
                notification.style.zIndex = '-100'

                //this.elementVisible=false;
        },
        capitalizarPrimeraLetra(str) {
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },
    },
    mounted: function(){
        this.timeOut = setTimeout(() => this.elementVisible = false, 10000);
        var img=document.getElementById("img");
        var notification=document.getElementById("notification");
        //notification.style.transform = "translate(0px)";
        notification.style.opacity = "1";
        //1=Student , 2=Parent
        if (this.user.rol_id===1){
            img.classList.add('border-student');
        }else{
            img.classList.add('border-parent');
        }
        this.user.firstname=this.capitalizarPrimeraLetra(this.user.firstname);
    },
}
</script>

<style lang="scss" scoped>
$color-background:#3960A5;
$color-background-body:#EDE9E3;
$color-student: #73B243;
$color-parent: #F3AD31;
$border-radius: 15px;
.notification{
    z-index: 100;
    width: 100%;
    max-width: 350px;
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    top: 5%;
    right: 0.5rem;
    background: $color-background;
    border-radius:$border-radius;
    transition: all ease 1s;
    opacity: 0;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media all and (min-width: 600px) {
        max-width: 400px;
    }
    &__control{
        z-index: 1;
        position: absolute;
        top: 1rem;
        right: 1.5rem;
        cursor: pointer;
   }
}
.wrap__notification{
    position: relative;
    background-color: $color-background-body;
    width: 100%;
    border-radius: $border-radius;
    padding: 10px 0 10px 0;
    &__title{
        text-align: center;
        color: $color-background;
    }
    &__body{
        display: grid;
        grid-template-columns: 50% 50%;
        &__img{
            width: 100px;
            height: 100px;
            border-radius: 50%;
            background-color: white;
            text-align: right;
            z-index: 1;
            margin: 0 auto;
        }
        &__username{
            background-color: white;
            line-height: 3rem;
            padding: 0 10px 0 50px;
            position: relative;
            left: -51%;
            z-index: 0;
            margin: 0 auto;
            height: 50px;
            top: 25%;
            border-top-right-radius:  $border-radius;
            border-bottom-right-radius: $border-radius;
            text-transform: capitalize;
        }
    }
}
.border-parent{
    border: 4px solid $color-parent;
}
.border-student{
     border: 4px solid $color-student;
}
</style>